var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-fade-transition",
    [
      _vm.value
        ? _c(
            "v-card",
            {
              staticClass: "structure-hover-tooltip",
              style: _vm.position,
              attrs: { elevation: "6" },
            },
            [
              _vm.title
                ? _c("span", { staticClass: "tooltip-name" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.title ? _c("br") : _vm._e(),
              _vm._v(" "),
              _c("strong", [_vm._v(_vm._s(_vm.residueLabel))]),
              _vm._v(" "),
              _vm.locationLabel ? _c("br") : _vm._e(),
              _vm._v(" "),
              _vm.locationLabel
                ? _c("span", [_vm._v(_vm._s(_vm.locationLabel))])
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }